export default __webpack_public_path__ + "static/media/car-vectors.9b1aeed1.jpg";